import { motion, AnimatePresence } from "framer-motion";
import logo from "@/assets/logo.jpeg";

const Loader = ({ show }) => (
  <AnimatePresence>
    {show && (
      <motion.div
        className="fixed inset-0 z-[100] flex items-center justify-center bg-[#f8fff8]"
        initial={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.6, ease: "easeInOut" }}
        data-testid="loader"
      >
        <div className="flex flex-col items-center">
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.6 }}
            className="relative"
          >
            <span className="absolute inset-0 rounded-full bg-[#40916c]/20 animate-ping" />
            <img src={logo} alt="Gupta Enterprises" className="relative h-20 w-20 rounded-full object-cover ring-1 ring-[#40916c]/15" />
          </motion.div>
          <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="mt-6 text-center"
          >
            <p className="font-display font-semibold text-[#2d6a4f] tracking-tight">Gupta Enterprises</p>
            <p className="font-body text-[10px] tracking-[0.3em] uppercase text-[#40916c]/70 mt-1">Vasavi Gold</p>
          </motion.div>
          <div className="mt-6 h-0.5 w-40 rounded-full bg-[#d8f3dc] overflow-hidden">
            <motion.div
              className="h-full bg-[#40916c]"
              initial={{ width: "0%" }}
              animate={{ width: "100%" }}
              transition={{ duration: 1.1, ease: "easeInOut" }}
            />
          </div>
        </div>
      </motion.div>
    )}
  </AnimatePresence>
);

export default Loader;
